import { parseResponse } from "helpers/common.lib";
import { baseApi } from "../../redux/baseAPI";

export const physicalExamApi = baseApi.injectEndpoints({
    tagTypes: ["PhysicalExam", "PeSoapText"],
    endpoints: (builder) => ({
        getPeTemplates: builder.query({
            query: (data) => {
                return {
                    url: `/physical_exams/get_pe_templates.json`,
                    method: "GET",
                    params: { ...data },
                };
            },
            transformResponse: (response, meta, arg) => {
                return parseResponse(response);
            },
            providesTags: (result) =>
                result?.data
                ? [
                    ...result?.data.map(({ id }) => ({ type: "PhysicalExam", id })),
                    { type: "PhysicalExam", id: "LIST" },
                    ]
                : [{ type: "PhysicalExam", id: "LIST" }],
        }),
        getPeSystems: builder.query({
            query: (params) => {
                return {
                    url: `/physical_exams/physical_exam_parent_file.json`,
                    method: "GET",
                };
            },
            transformResponse: (response, meta, arg) => response.response.data,
        }),
        getPeSoapText: builder.query({
            query: (data) => {
                return {
                    url: `/physical_exams/get_soap_against_encounter.json`,
                    method: "GET",
                    params: { ...data }
                };
            },
            transformResponse: (response, meta, arg) => response.response.data,
            providesTags: ["PeSoapText"]
        }),
        updateTemplate: builder.mutation({
            query: (body) => ({
              url: `/physical_exams/add_pe_template.json`,
              method: "POST",
              data: body,
            //   params: { ...body },
            }),
            invalidatesTags: ["PhysicalExam"],
            transformResponse: (response, meta, arg) => response.response,
        }),
        savePhysicalExam: builder.mutation({
            query: (body) => ({
              url: `/physical_exams/save_physical_exam.json`,
              method: "POST",
              data: body,
            }),
            transformResponse: (response, meta, arg) => response.response,
        }),
        deletePhysicalExam: builder.mutation({
            query: (body) => ({
              url: `/physical_exams/del_template.json`,
              method: "POST",
              data: body,
            }),
            invalidatesTags: ["PhysicalExam"],
            transformResponse: (response, meta, arg) => response.response,
        }),
        deAttachPhysicalExam: builder.mutation({
            query: (body) => ({
              url: `/physical_exams/remove_physical_exam.json`,
              method: "POST",
              data: body,
            }),
            transformResponse: (response, meta, arg) => response.response,
        }),
        makeDefault: builder.mutation({
            query: (body) => ({
              url: `/physical_exams/make_default.json`,
              method: "POST",
              data: body,
            }),
            invalidatesTags: ["PhysicalExam"],
            transformResponse: (response, meta, arg) => response.response,
        }),
        copyTemplate: builder.mutation({
            query: (body) => ({
              url: `/physical_exams/copy_template.json`,
              method: "POST",
              data: body,
            }),
            invalidatesTags: ["PhysicalExam"],
            transformResponse: (response, meta, arg) => response.response,
        }),
        getPresetSystem: builder.query({
            query: (data) => {
                return {
                    url: `/physical_exams/read_preset_system.json`,
                    method: "GET",
                    params: { ...data }
                };
            },
            transformResponse: (response, meta, arg) => response.response.data,
        }),
        getPresetSystemDetail: builder.query({
            query: (data) => {
                return {
                    url: `/physical_exams/detail_preset_system.json`,
                    method: "GET",
                    params: { ...data }
                };
            },
            transformResponse: (response, meta, arg) => response.response.data,
        }),
    })
});

export const {
  useGetPeTemplatesQuery,
  useGetPeSystemsQuery,
  useGetPeSoapTextQuery,
  useUpdateTemplateMutation,
  useSavePhysicalExamMutation,
  useDeletePhysicalExamMutation,
  useDeAttachPhysicalExamMutation,
  useMakeDefaultMutation,
  useCopyTemplateMutation,
  useGetPresetSystemQuery

} = physicalExamApi;
